import {useRequestHelper} from "@/helpers/request.helper";
import type {LoginInternoCommand} from "@/domain/commands/auth.commands";
import type {EncerrarUsuarioSessaoCommand, VerificarUsuarioSessaoCommand} from "@/domain/commands/usuario.commands";
import {useAuthStore} from "@/stores/auth.store";
import type {UsuarioInternoVm} from "@/domain/type/usuario.type";
import type {UsuarioInternoLoginVm} from "@/domain/type/auth.type";



const requestHelper = useRequestHelper();



class AuthService {

    login(userCommand: LoginInternoCommand) {
        return requestHelper.sendRequestPost<UsuarioInternoLoginVm>('usuario/interno/login', userCommand, false);
    }

    verificarSessao(command: VerificarUsuarioSessaoCommand) {
        return requestHelper.sendRequestPost<UsuarioInternoLoginVm>('usuario/interno/sessao/verificar', command, false);
    }

    verificarUsuarioAutenticado() {
        return requestHelper.sendRequestGet<UsuarioInternoVm>('usuario/interno/info');
    }



}

export default new AuthService();